
import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Plus, Edit, Trash2, Search, Shield, UserCog } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import UsersList from './UsersList';
import UserGroups from './UserGroups';
import UserPermissions from './UserPermissions';

const UserManagement = () => {
  const [searchQuery, setSearchQuery] = useState('');
  
  return (
    <div>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
        <h2 className="text-2xl font-bold">User Management</h2>
        
        <div className="flex gap-2 w-full sm:w-auto">
          <div className="relative flex-grow sm:flex-grow-0">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              type="search"
              placeholder="Search users..."
              className="pl-8 w-full sm:w-[200px]"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            Add User
          </Button>
        </div>
      </div>
      
      <Tabs defaultValue="users" className="w-full">
        <TabsList className="mb-4 w-full justify-start border-b pb-0 overflow-x-auto">
          <TabsTrigger value="users" className="rounded-b-none data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Users
          </TabsTrigger>
          <TabsTrigger value="groups" className="rounded-b-none data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Groups
          </TabsTrigger>
          <TabsTrigger value="permissions" className="rounded-b-none data-[state=active]:border-b-2 data-[state=active]:border-primary">
            Permissions
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="users" className="py-4">
          <UsersList searchQuery={searchQuery} />
        </TabsContent>
        
        <TabsContent value="groups" className="py-4">
          <UserGroups searchQuery={searchQuery} />
        </TabsContent>
        
        <TabsContent value="permissions" className="py-4">
          <UserPermissions />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default UserManagement;
